export default __webpack_public_path__ + "0323de5.png";